module.exports = {"notification.message":"Wix.com usa cookies para brindarte la mejor experiencia posible.","notification.got.it":"¡Entendido!","notification.more.info":"Leer más","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_es.json
// module id = 47
// module chunks = 0